// extracted by mini-css-extract-plugin
module.exports = {"SettingsSaveRow":"styles_SettingsSaveRow__3TLb_","MenuCell":"styles_MenuCell__1WuIz"};